import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { WEB_COMPONENT_DASHBOARD } from '../../webcomponents.constants';
import { DashboardWebComponent } from '../..';
import { DisplayMode, TemplateState } from '../../types/common/types';
import { Status } from '@nirvana/shared/dtos/types/dashboards/common';
import { Dashboards } from '../../types';

export class DashboardAppView extends BaseWebComponentView {
  protected translations: any;
  protected commonStrings: any;

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$title = this.shadow.querySelector('.title');
    this.dom.$dashboards = this.shadow.querySelector('.dashboards');
    this.dom.$dashboardErrMessage = this.shadow.querySelector('.dashboard-error--message');
    this.dom.$dashboardEmptyMessage = this.shadow.querySelector('.dashboard-empty--message');
    this.dom.$dashboardsList = [];

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getDashboardsAppStrings();
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings() {
    this.dom.$title.innerHTML = this.translations.title;
  }

  buildSuccessView(data: Dashboards) {
    this.resetTemplateState(this.dom.$wrapper);
    this.dom.$dashboards.innerHTML = '';
    this.dom.$dashboardsList = [];

    if (data.status === Status.ACTIVE) {
      // For now, support only one dashboard!
      if (!Array.isArray(data.dashboards) || data.dashboards.length !== 1) {
        return;
      }

      data.dashboards.forEach(dashboard => {
        const $dashboard = document.createElement(WEB_COMPONENT_DASHBOARD) as DashboardWebComponent;
        $dashboard.injectDependencies(this.dependencies);
        $dashboard.dashboardId = dashboard.id;
        $dashboard.dashboardTitle = dashboard.title;
        $dashboard.dashboardType = dashboard.type;
        $dashboard.widgets = dashboard.widgets || [];
        $dashboard.timeRange = dashboard.timeRange;
        $dashboard.reportingPeriod = dashboard.reportingPeriod;
        $dashboard.initialSelectedTarget = dashboard.selectedTarget || {};
        $dashboard.initialAvailableCompanies = data.targets || [];
        $dashboard.displayMode = data.displayMode ?? DisplayMode.DASHBOARD;
        $dashboard.isPartner = data.isPartner;
        // If canDrillDown is not set from the backend, we take false as default.
        $dashboard.canDrillDown = dashboard.canDrillDown || false;
        $dashboard.features = dashboard.features;
        $dashboard.hasReportsEnabled = data.hasReportsEnabled;

        this.dom.$dashboards.appendChild($dashboard);
        this.dom.$dashboardsList.push($dashboard);

        $dashboard.start().then().catch();
      });

      return;
    }

    if (data.status === Status.NO_COMPANIES_IN_TARGETS) {
      this.buildNoCompaniesInTargetsView();
      return;
    }

    this.buildErrorView();
  }

  buildNoCompaniesInTargetsView() {
    this.resetTemplateState(this.dom.$wrapper);
    this.dom.$dashboardEmptyMessage.innerHTML = this.translations.noCompaniesInTargets;
    this.setTemplateState(this.dom.$wrapper, TemplateState.EMPTY);
  }

  buildErrorView() {
    this.resetTemplateState(this.dom.$wrapper);
    this.dom.$dashboardErrMessage.innerHTML = this.commonStrings.generalSystemError;
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
